export default async function VerificaEstudiante(token) {
  const DrupalUrl = process.env.REACT_APP_DRUPAL_CONEXION_API || 'http://localhost:3005'
  const MiscUrl = process.env.REACT_APP_MISC_API || 'http://localhost:3002'

  await fetch(`${DrupalUrl}/process/isEstudiante`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      authorization: token,
    }
  })
  .then(async response => {
    const datos = await response.json()
    if (datos.body[0]?.Estudiante > 0) {
      await fetch(`${MiscUrl}/estudiante`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          authorization: token,
        }
      })
      .catch(err => {
        console.log(err)
      })
    } else {
      await fetch(`${MiscUrl}/estudiante`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          authorization: token,
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  })
  .catch(err => {
    console.log(err)
  })
}